// import React from 'react'
import "./Image.css";
import Loader from "./Loader";
import { connect } from "react-redux";
// function Image({ message }) {
//   return (
//     <div className='msg__image-main'>
//       <img src={message.content.link} />
//       <div>{message.content.text}</div>
//     </div>
//   )
// }

// export default Image
import React, { useEffect, useState } from "react";
import Retry from "./Retry";
import { chatAction, messageAction } from "../../../../../store/action";
import { chatSelector } from "../../../../../store/selector";
import APIManager from "modules/common/apiManager";
import {
  changeLastMessage,
  createChatEvent,
} from "../../../../../dialpad/service/chat.service";
import { getTime } from "../../utils";
import styled from "styled-components";
import { formatMessage } from "../utils/generic";

const CustomerImage = styled.div`
  width: 250px;
  .caption {
    // font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    margin-top: 10px;
    padding: 0px 8px 0px 8px;
  }

  .full-screen-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .9);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  
  .full-screen-container {
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .full-screen-img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 10px;
  }

  .closeButton {
    position: fixed;
    top: 5%;
    right: 45px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    z-index: 1100;
    color: rgb(255, 255, 255);
  }
`;

const AgentImage = styled.div`
  width: 250px;
  .caption {
    // font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    margin-top: 10px;
    // color: #fff;
    padding: 0px 8px 0px 8px;
  }

  .full-screen-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .9);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .full-screen-container {
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .full-screen-img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 10px;
  }

  .closeButton {
    position: fixed;
    top: 5%;
    right: 45px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    z-index: 1100;
    color: rgb(255, 255, 255);
  }
`;

const mAPI = new APIManager();

const ImageOrientationChecker = ({ message, link, size = "sm", ...props }) => {
  const {
    dynamicUpdate,
    selectedImages: selectedImagesFromRedux,
    retryImages,
    selectedAssignedList,
    messageList,
  } = props;
  const [isHorizontal, setIsHorizontal] = useState(null);
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    setIsHorizontal(naturalWidth > naturalHeight);
  };

  const handleImageClick = () => {
    setIsFullScreen(true);
  };

  const handleCloseFullScreen = () => {
    setIsFullScreen(false);
  };

  const caption = (message && message.content && message.content.caption) || "";
  let imgLink = "";
  if (link) {
    imgLink = link;
  } else {
    imgLink = (message && message.content && message.content.link) || "";
  }

  let className = isHorizontal
    ? "msg-image__horizontal"
    : "msg-image__vertical";
  if (size === "lg") {
    className += " large-image";
  }

  const loadingFn = ({ detail }) => {
    const msgId = message && message.id;
    if (msgId === detail.id) {
      if (detail.success === false) {
        setError(true);
        setLoading(null);
        return;
      }
      setLoading(detail.loading);
    }
  };

  useEffect(() => {
    window.addEventListener("custom-chat-event", loadingFn);

    return () => {
      window.removeEventListener("custom-chat-event", loadingFn);
    };
  }, []);

  useEffect(() => {
    console.log("this is error called by", error);
  }, [error]);

  const getPixel = () => {
    if (!loading) return 0;
    if (loading < 25) {
      return 1;
    } else if (loading < 50) {
      return 0.75;
    } else if (loading < 99) {
      return 0.25;
    } else {
      return 0;
    }
  };

  const getPublicUrl = (formData, uniqueId, currImg) => {
    const id = message && message.id;
    // const event = createChatEvent({id:id, loading : 0})
    // window.dispatchEvent(event)
    return new Promise((res, rej) => {
      mAPI.sendPostForm(
        `chat/upload`,
        formData,
        (data) => {
          res(data);
        },
        (errorCode, data) => {
          // const event = createChatEvent({id: uniqueId, success: false})
          // window.dispatchEvent(event)
          setError(true);
          let alreadyExist = false;
          if (message && message.error && message.error) {
            alreadyExist = true;
          }
          // for (const image of retryImages) {
          //   if(image.uniqueId === currImg.uniqueId){
          //     alreadyExist = true;
          //   }
          // }
          if (!alreadyExist) {
            dynamicUpdate({
              data: {
                key: `messageList.${selectedAssignedList.identifier}`,
                value: [
                  ...messageList[`${selectedAssignedList.identifier}`].map(
                    (d) => {
                      if (d.id === uniqueId) {
                        return { ...d, error: true };
                      }
                      return d;
                    }
                  ),
                ],
              },
            });
          }
        },
        "private",
        (data) => {
          const progress = Math.round((100 * data.loaded) / data.total);
          // const event = createChatEvent({id:uniqueId, loading : progress})
          // window.dispatchEvent(event)

          dynamicUpdate({
            data: {
              key: `messageList.${selectedAssignedList.identifier}`,
              value: [
                ...messageList[`${selectedAssignedList.identifier}`].map(
                  (d) => {
                    if (d.id === uniqueId) {
                      delete d.error;
                      return { ...d };
                    }
                    return d;
                  }
                ),
              ],
            },
          });
          setError(false);
          setLoading(progress);
        }
      );
    });
  };

  const sendMessage = async (e) => {
    // const uniqueId = uuidv4();
    const {
      configProcessor,
      messageList,
      assignedList,
      selectedAssignedList,
      dynamicUpdate,
    } = props;
    let currImg = {};
    currImg = message && message.content.file;
    // for(let image of retryImages){
    //   if(image.uniqueId === message.id){
    //     currImg = image;
    //   }
    // }
    const mimeType = currImg.type;
    const commonPayload = {
      from: "agent",
      timeStamp: getTime(),
      type: "image",
      content: {
        link: URL.createObjectURL(currImg),
        mimeType: mimeType,
        fileName: currImg.name,
        fileSize: currImg.size,
      },
      // "id": uniqueId,
      loading: 0,
    };
    // dynamicUpdate({ data: { key: `messageList.${selectedAssignedList.identifier}`, value: [...messageList[selectedAssignedList.identifier] || [], commonPayload] } })
    const formData = new FormData();
    formData.append("file", currImg);
    const data = await getPublicUrl(formData, message.id, currImg);
    // got public url, so remove this image from retry image in redux
    const messagePayload = {
      ...commonPayload,
      content: {
        ...data,
        mimeType: mimeType,
      },
    };
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      payloadType: "message",
      "rmq:pattern": "agent:message",
      message: {
        ...(selectedAssignedList && selectedAssignedList.message),
        ...messagePayload,
      },
    });

    changeLastMessage({
      list: assignedList,
      identifier: selectedAssignedList.identifier,
      receivedMessage: messagePayload,
      key: "assignedList",
    });
  };

  useEffect(() => {
    if (message && message.error && message.error) {
      setError(true);
    }
    // for (const image of retryImages) {
    //   if(image.uniqueId === message && message.id){
    //     if(image.status === 'pending'){
    //       setError(true)
    //     } else if(image.status === 'processing'){
    //       setLoading(image.progress);
    //     }
    //   }
    // }
  }, []);

  const MessageImage = message.from == "customer" ? CustomerImage : AgentImage;

  return (
    <MessageImage>
      <div className="msg-image__main">
        {/* {loading} */}
        {loading && loading < 100 && <Loader loadingPercentage={loading} />}
        {error && <Retry onClick={() => sendMessage()} />}
        <img
          // loading={"lazy"}
          src={`${imgLink}`}
          alt="Image"
          style={{ filter: `blur(${getPixel()}px)`, cursor: "pointer" }}
          // onLoad={handleImageLoad}
          className="msg-image__img"
          // style={{ cursor: "pointer" }}
          onClick={handleImageClick}
        />
        {/* {message && message.loading} */}
      </div>
      {isFullScreen && (
        <div className="full-screen-overlay" onClick={handleCloseFullScreen}>
          <span class="material-symbols-outlined closeButton" onClick={handleCloseFullScreen}>
            cancel
          </span>
          <div className="full-screen-container">
            <img src={imgLink} alt="Full-Screen Image" className="full-screen-img" />
          </div>
        </div>
      )}
      <p className="caption" dangerouslySetInnerHTML={{ __html: formatMessage(caption && caption) }} />
    </MessageImage>
  );
};

// export default ImageOrientationChecker;
const stateToProps = (state) => ({
  selectedAssignedList: chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  ),
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  assignedList: chatSelector.getChatDynamic(state, "assignedList"),
  selectedImages: chatSelector.getChatDynamic(state, "selectedImages"),
  retryImages: chatSelector.getChatDynamic(state, "retryImages"),
});

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
});
export default connect(stateToProps, dispatchToProps)(ImageOrientationChecker);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/Image.js